import { render, staticRenderFns } from "./CheckDetail.vue?vue&type=template&id=0fe627ce&scoped=true"
import script from "./CheckDetail.vue?vue&type=script&lang=js"
export * from "./CheckDetail.vue?vue&type=script&lang=js"
import style0 from "./CheckDetail.vue?vue&type=style&index=0&id=0fe627ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe627ce",
  null
  
)

export default component.exports